<div class="overflow-y-auto flex flex-col">
  <ng-content></ng-content>
</div>
